import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment, sentryOptions } from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  Sentry.init(sentryOptions);

  enableProdMode();
  console.log = () => null;
  console.info = () => null;
  console.warn = () => null;
  console.error = () => null;
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
